// Export the Component Definition for use in Contentful Studio
export {VideoContentfulComponentDefinition} from './videoContentfulDefinition';
export {default} from './Video';
